
import React, { useContext } from 'react'
import {
  Grid,
  Typography,
  makeStyles,
  Card,
  CardContent,
  Divider,
  Tooltip,
  Fab,
  Button, Modal,
  Backdrop, Fade,
  TableContainer,
  Table, TableCell, TableRow,
  TableBody
} from '@material-ui/core';


import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';

import CommuteOutlinedIcon from '@material-ui/icons/CommuteOutlined';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import BallotOutlinedIcon from '@material-ui/icons/BallotOutlined';
import CardTravelOutlinedIcon from '@material-ui/icons/CardTravelOutlined';

import TrendingDownOutlinedIcon from '@material-ui/icons/TrendingDownOutlined';
import DomainOutlinedIcon from '@material-ui/icons/DomainOutlined';
import ImportContactsOutlinedIcon from '@material-ui/icons/ImportContactsOutlined';
import TblAcreditacionModal from '../ConsultaInformeModal/TblAcreditacionModal';
import { TblOrdenesnoPagoModal } from '../ConsultaInformeModal/TblOrdenesnoPagoModal';
import TblSociedadesModal from '../ConsultaInformeModal/TblSociedadesModal';
import TblProtestosModal from '../ConsultaInformeModal/TblProtestosModal';
import TblMorosidadModal from '../ConsultaInformeModal/TblMorosidadModal';

import UserContext from '../../context/Globales/UserContext';
import TblPropiedadesModal from '../ConsultaInformeModal/TblPropiedadesModal';
import { TblBoletinLaboModal } from '../ConsultaInformeModal/TblBoletinLaboModal';
import { TblDetalleVehiculoModal } from '../ConsultaInformeModal/TblDetalleVehiculoModal';



const useStyles = makeStyles((theme) => ({
  tituloTable: {

    backgroundColor: theme.palette.primary.main,
    minWidth: 200,
    color: 'white',
    textAlign: 'center',
    padding: '20px',
    fontWeight: '250',
    fontSize: '35px'
  },
  TituloIdentificacion: {

    backgroundColor: theme.palette.primary.main,
    backgroundImage: `url(${process.env.PUBLIC_URL + '/static/imagen/fondo.jpg'})`,
    minWidth: '200',
    color: 'black',
    textAlign: 'left',
    padding: '15px',
    fontWeight: '450',
    fontSize: '18px',
    height: 'auto',
    alignContent: 'center',
  },

  buttonVermas: {
    color: 'white',

    '&:hover': {
      width: '100%',
      backgroundColor: '#1976d2',
      color: 'white',

    }


  },

  fondoCardIndicadores: {

    backgroundColor: theme.palette.fondotitulos.main,
    minWidth: 'auto',
    color: '#171717',
    textAlign: 'center',
    margin: '10px',
    padding: '15px',
    fontWeight: '300',
    fontSize: '14px',
    height: '145px',
    alignContent: 'center',

    '&:hover': {
      backgroundColor: theme.palette.fondoSeleccionIndicador.main,
      minWidth: 200,
      color: '#171717',
      padding: '15px',
      fontWeight: '320',
      height: 'auto',

    },

  },

  FondoTable: {

    backgroundColor: theme.palette.greyFondo.main
  },
  indicadores: {
    padding: '60px',
    alignContent: 'center',

  },
  buttonSuccess: {
    backgroundColor: '#04ba65',
    color: 'white',
    size: '15px',
    '&:hover': {
      backgroundColor: '#02bf67',
      color: 'white',
    },
  },

  ButtonDanger: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    '&:hover': {
      backgroundColor: '#a1122e',
      color: 'white',
    },

  },
  buttonGray: {
    backgroundColor: '#cfcaca',
    color: 'white',
    '&:hover': {
      backgroundColor: '#dedcdc',
      color: 'white',
    },
  },

  sizeIcono: {

    height: '38px',
    width: '38px'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    overflow: 'scroll',
    height: '100%',
  },


  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '70%',
    height: '100%',
    overflow: 'scroll',
  },

  FondoTable: { backgroundColor: theme.palette.greyFondo.main },

  mousePointer: { cursor: 'pointer' },



}));

const IndicadoresPositivoNegativoModal = () => {
  const classes = useStyles();
  const { datoICMODAL, DatodetalleVehiculosModal, DatodetalleBoletinModal, DatoListaSAModal, DatodetallePropBienesModal } = useContext(UserContext);
  const [DatoBAnco] = React.useState(datoICMODAL.DetalleInformacionPositiva?.MovimientosDeBancos);

  const userContext = useContext(UserContext);

  const [OpenModalAcreditacion, setOpenModalAcreditacion] = React.useState(false);
  const [OpenModalSociedades, setOpenModalSociedades] = React.useState(false); //
  const [OpenMOdalProtestos, setOpenMOdalProtesto] = React.useState(false);
  const [OpenMOdalMorosidad, setOpenModalMorosidad] = React.useState(false);
  const [OpenModalPropiedades, setOpenModalPropiedades] = React.useState(false);
  const [OpenModalBoletin, setOpenModalBoletin] = React.useState(false);

  const [OpenModalVehiculo, setOpenModalVehiculo] = React.useState(false);

  const handleClickVehiculo = () => {
    if (DatodetalleVehiculosModal == null) {
    
      setOpenModalVehiculo(true);
      userContext.getDetalleVehiculoModal(datoICMODAL.Identificacion?.Rut.replace(/[.]/g, ''), datoICMODAL.ID);
    } else {
      setOpenModalVehiculo(true);
    }
  };
  const handleClickVehiculoClosed = () => {
    setOpenModalVehiculo(false);
  };


  const handleClickBoletin = () => {

    if (DatodetalleBoletinModal == null || DatodetalleBoletinModal == 'ERROR CONSULTA') {
      setOpenModalBoletin(true);
      userContext.getDetalleBoletinModal(datoICMODAL.Identificacion?.Rut.replace(/[.]/g, ''), datoICMODAL.ID);
    } else {
      setOpenModalBoletin(true);
    }


  };
  const handleClickBoletinClosed = () => {
    setOpenModalBoletin(false);
  };

  const hanleClickOpenMorosidad = () => {
    setOpenModalMorosidad(!OpenMOdalMorosidad);
  };

  const hanleClickOpenProtesto = () => {
    setOpenMOdalProtesto(!OpenMOdalProtestos);

  };

  const hanleClickOpenSociedades = () => {

    if (DatoListaSAModal == null || DatoListaSAModal == 'ERROR CONSULTA ASOCIADOS') {
      //  console.log('modal sociedades');
      setOpenModalSociedades(true);
      userContext.getLitadeSociosAsociadosModal(datoICMODAL.Identificacion?.Rut.replace(/[.]/g, ''), datoICMODAL.ID);
    } else {
      //  console.log('modal sociedades 1');
      setOpenModalSociedades(true);
    }


  };

  const hanleClickOpenSociedadesClosed = () => {
    setOpenModalSociedades(false);
  };

  const handleClickOpenAcreditacion = () => {

    setOpenModalAcreditacion(!OpenModalAcreditacion);
  };

  const handleClickOpenPropiedades = () => {
    if (DatodetallePropBienesModal == null || DatodetallePropBienesModal == 'ERROR CONSULTA PROPIEDADES') {
      setOpenModalPropiedades(true);
      userContext.getDetallePropBienesModal(datoICMODAL.Identificacion?.Rut.replace(/[.]/g, ''), datoICMODAL.ID);
    } else {
      setOpenModalPropiedades(true);
    }

  };

  const handleClickOpenPropiedadesClosed = () => {
    setOpenModalPropiedades(false);
  }

  return (
    <div>

      {/** Vehiculos */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"

        className={classes.modal}
        open={OpenModalVehiculo}
        onClose={handleClickVehiculoClosed}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenModalVehiculo}>
          <div className={classes.paper}>


            <Typography variant="h5" align="right" onClick={handleClickVehiculoClosed} className={classes.mousePointer} >X</Typography>

            <TblDetalleVehiculoModal />

          </div>
        </Fade>
      </Modal>

      {/** Boletin Laboral */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalBoletin}
        onClose={handleClickBoletinClosed}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenModalBoletin}>
          <div className={classes.paper}>


            <Typography variant="h5" align="right" onClick={handleClickBoletinClosed} className={classes.mousePointer} >X</Typography>

            <TblBoletinLaboModal />

          </div>
        </Fade>
      </Modal>

      {/** Propiedades y bienes */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalPropiedades}
        onClose={handleClickOpenPropiedadesClosed}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenModalPropiedades}>
          <div className={classes.paper}>


            <Typography variant="h5" align="right" onClick={handleClickOpenPropiedadesClosed} className={classes.mousePointer} >X</Typography>

            <TblPropiedadesModal />
          </div>
        </Fade>
      </Modal>
      {/* Acreditacion*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalAcreditacion}
        onClose={handleClickOpenAcreditacion}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenModalAcreditacion}>
          <div className={classes.paper}>

            <Typography variant="h5" align="right" onClick={handleClickOpenAcreditacion} className={classes.mousePointer} >X</Typography>
            <TblAcreditacionModal />
            <Divider />
            <TblOrdenesnoPagoModal />
          </div>
        </Fade>
      </Modal>

      {/** Sociedades */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalSociedades}
        onClose={hanleClickOpenSociedadesClosed}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenModalSociedades}>
          <div className={classes.paper}>


            <Typography variant="h5" align="right" onClick={hanleClickOpenSociedadesClosed} className={classes.mousePointer} >X</Typography>

            <TblSociedadesModal />
          </div>
        </Fade>
      </Modal>




      {/** Protesto */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenMOdalProtestos}
        onClose={hanleClickOpenProtesto}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenMOdalProtestos}>
          <div className={classes.paper}>


            <Typography variant="h5" align="right" onClick={hanleClickOpenProtesto} className={classes.mousePointer} >X</Typography>

            <TblProtestosModal />
          </div>
        </Fade>
      </Modal>

      {/** MOrosidad */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenMOdalMorosidad}
        onClose={hanleClickOpenMorosidad}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenMOdalMorosidad}>
          <div className={classes.paper}>


            <Typography variant="h5" align="right" onClick={hanleClickOpenMorosidad} className={classes.mousePointer} >X</Typography>

            <TblMorosidadModal />
          </div>
        </Fade>
      </Modal>


      <br />

      <Grid component="main">

        <div className={classes.TituloIdentificacion}>INDICADORES COMPORTAMIENTO</div>


        <CardContent>


          <Grid
            container
            direction="row"
            spacing={2}
          >

            <Grid item xs={6} sm={6} xl={3} md={3} lg={3}>
              <Card >
                <div className={classes.fondoCardIndicadores}><HomeWorkOutlinedIcon className={classes.sizeIcono} /> <br />Registra Propíedades

                  <CardContent>
                    <div align="center">
                      <Fab aria-label="save" className={datoICMODAL.DetalleInformacionPositiva?.BienesRaicesNumeroPropiedades > 0 ? classes.buttonSuccess : classes.buttonGray} align="center" size="small"
                      >
                        <Typography variant="h6" align="center" >{datoICMODAL.DetalleInformacionPositiva?.BienesRaicesNumeroPropiedades > 0 ? 'SI' : 'NO'}</Typography>

                      </Fab>
                    </div>
                  </CardContent>
                  <hr />

                  <TableContainer>
                    <Table>
                      {datoICMODAL.DetalleInformacionPositiva?.BienesRaicesNumeroPropiedades > 0 ? (
                        <TableBody>

                          <TableRow>
                            <TableCell style={{ width: '30%' }}>N° Propiedades:</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '70%' }}><strong> {datoICMODAL.DetalleInformacionPositiva?.BienesRaicesNumeroPropiedades}</strong></TableCell>

                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '30%' }}>Total Avalúo:</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '70%' }}><strong>{datoICMODAL.DetalleInformacionPositiva?.BienesRaicesAvaluoFiscal}</strong></TableCell>
                          </TableRow>


                        </TableBody>
                      ) : ''}
                    </Table>
                  </TableContainer>


                  <br />
                  <Button variant="contained" color="primary" className={classes.buttonVermas} onClick={handleClickOpenPropiedades} disabled={datoICMODAL.DetalleInformacionPositiva?.BienesRaicesNumeroPropiedades > 0 ? false : true} >Ver información  </Button>
                </div>
              </Card>

            </Grid>
            <Grid item xs={6} sm={6} xl={3} md={3} lg={3}>
              <Card>
                <div className={classes.fondoCardIndicadores}> <CommuteOutlinedIcon className={classes.sizeIcono} /> <br />Registra Vehículo

                  <CardContent>
                    <div align="center">
                      <Fab
                        aria-label="save"
                        className={datoICMODAL.DetalleInformacionPositiva?.PoseeVehiculos ? classes.buttonSuccess : classes.buttonGray} align="center" size="small">
                        <Typography variant="h6" align="center" >{datoICMODAL.DetalleInformacionPositiva?.PoseeVehiculos ? 'SI' : 'NO'}</Typography>
                      </Fab>

                    </div>
                  </CardContent>
                  <hr />

                  {datoICMODAL.DetalleInformacionPositiva?.PoseeVehiculos ? (
                    <TableContainer>

                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>Total de Vehículos:</TableCell>
                            <TableCell><strong>{datoICMODAL.DetalleInformacionPositiva?.NumeroVehiculos}</strong></TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>

                    </TableContainer>
                  ) : ''}


                  <br />
                  <Button variant="contained" color="primary" className={classes.buttonVermas} onClick={handleClickVehiculo} disabled={datoICMODAL.DetalleInformacionPositiva?.PoseeVehiculos ? false : true} >Ver información</Button>
                </div>
              </Card>

            </Grid>


            <Grid item xs={6} sm={6} xl={3} md={3} lg={3}  >
              {datoICMODAL.DetalleInformacionPositiva?.MovimientosDeBancos == '0:-' ? (
                <Card>
                  <div className={classes.fondoCardIndicadores}><CardTravelOutlinedIcon className={classes.sizeIcono} /> <br />Acreditación

                    <CardContent >
                      <div align="center">

                        <Fab
                          aria-label="save"
                          className={datoICMODAL.DetalleInformacionPositiva?.MovimientosDeBancos == '0:-' ? classes.ButtonDanger : classes.buttonSuccess}
                          align="center"
                          size="small"
                        >
                          <Tooltip title="Ver más información">
                            <Typography variant="h6" align="center" >{datoICMODAL.DetalleInformacionPositiva?.MovimientosDeBancos == '0:-' ? 'NO' : 'SI'}</Typography>
                          </Tooltip>

                        </Fab>


                      </div>
                    </CardContent>
                    <hr />

                    <br />
                    <Button variant="contained" color="primary" className={classes.buttonVermas} onClick={handleClickOpenAcreditacion} disabled={datoICMODAL.DetalleInformacionPositiva?.MovimientosDeBancos == '0:-' ? true : false} >Ver información</Button>
                  </div>
                </Card>

              ) : <Card>
                <div className={classes.fondoCardIndicadores}><CardTravelOutlinedIcon className={classes.sizeIcono} /> <br />Acreditación

                  <CardContent >
                    <div align="center">

                      <Fab
                        aria-label="save"
                        className={datoICMODAL.DetalleInformacionPositiva?.MovimientosDeBancos != null ? classes.buttonSuccess : classes.ButtonDanger}
                        align="center"
                        size="small"
                      >
                        <Tooltip title="Ver más información">
                          <Typography variant="h6" align="center" >{datoICMODAL.DetalleInformacionPositiva?.MovimientosDeBancos != null ? 'SI' : 'NO'}</Typography>
                        </Tooltip>

                      </Fab>


                    </div>

                  </CardContent>
                  <hr />

                  {datoICMODAL.DetalleInformacionPositiva?.MovimientosDeBancos != null ? (
                    <TableContainer>

                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>Cant. Banco:</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell><strong>{DatoBAnco}</strong></TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>

                    </TableContainer>
                  ) : ''}



                  <br />
                  <Button variant="contained" color="primary" className={classes.buttonVermas} onClick={handleClickOpenAcreditacion} disabled={datoICMODAL.DetalleInformacionPositiva?.MovimientosDeBancos != null ? false : true} >Ver información</Button>
                </div>
              </Card>}

            </Grid>


            <Grid item xs={6} sm={6} xl={3} md={3} lg={3}  >
              {datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSociedad > 0 ?


                <Card>
                  <div className={classes.fondoCardIndicadores}><DomainOutlinedIcon className={classes.sizeIcono} /><br />Sociedades


                    <CardContent>
                      <div align="center">

                        <Fab
                          aria-label="save"
                          className={datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSociedad > 0 ? classes.buttonSuccess : classes.ButtonDanger}
                          align="center"
                          size="small"
                        >
                          <Typography variant="h6" align="inherit" >{datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSociedad > 0 ? 'SI' : 'NO'}</Typography>
                        </Fab>


                      </div>
                    </CardContent>
                    <hr />

                    <TableContainer>
                      <Table>
                        <TableBody>

                          <TableRow>
                            <TableCell>Sociedades:</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>{datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSociedad > 0 ? (<strong>{datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSociedad}</strong>) : '0'}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Socios:</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>{datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSocio > 0 ? (<strong>{datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSocio}</strong>) : '0'}</TableCell>
                          </TableRow>



                        </TableBody>
                      </Table>
                    </TableContainer>



                    <br />
                    <Button variant="contained" color="primary" className={classes.buttonVermas} onClick={hanleClickOpenSociedades} disabled={datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSociedad > 0 ? false : true} >Ver información </Button>

                  </div>
                </Card>
                : <Card>
                  <div className={classes.fondoCardIndicadores}><DomainOutlinedIcon className={classes.sizeIcono} /><br />Sociedades

                    <CardContent>
                      <div align="center">

                        <Fab
                          aria-label="save"
                          className={datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSocio > 0 ? classes.buttonSuccess : classes.ButtonDanger}
                          align="center"
                          size="small"
                        >
                          <Typography variant="h6" align="inherit" >{datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSocio > 0 ? 'SI' : 'NO'} </Typography>
                        </Fab>


                      </div>
                    </CardContent>
                    <hr />
                    <TableContainer>
                      <Table>
                        <TableBody>

                          <TableRow>
                            <TableCell>Sociedades:</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>{datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSociedad > 0 ? (<strong>{datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSociedad}</strong>) : '0'}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Socios:</TableCell>
                            <TableCell>{datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSocio > 0 ? (<strong>{datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSocio}</strong>) : '0'}</TableCell>
                          </TableRow>



                        </TableBody>
                      </Table>
                    </TableContainer>
                    <br />
                    <Button variant="contained" color="primary" className={classes.buttonVermas} onClick={hanleClickOpenSociedades} disabled={datoICMODAL.DetalleInformacionPositiva?.PublicacionesComoSocio > 0 ? false : true} >Ver información </Button>

                  </div>
                </Card>}

            </Grid>


          </Grid>


          <Grid
            container
            direction="row"
            spacing={2}
          >
            <Grid item xs={6} sm={6} xl={3} md={3} lg={3}  >
              <Card >
                <div className={classes.fondoCardIndicadores}> <TrendingDownOutlinedIcon className={classes.sizeIcono} /><br />Registro de Quiebra

                  <CardContent >
                    <div align="center">

                      <Fab
                        aria-label="save"
                        className={datoICMODAL.SemaforoInformacion?.RegistroQuiebras ? classes.ButtonDanger : classes.buttonSuccess}
                        align="left"
                        size="small"
                      >

                        <Tooltip title="Ver más información">
                          <Typography variant="h6" align="center">{datoICMODAL.SemaforoInformacion?.RegistroQuiebras ? 'SI' : 'NO'}</Typography>
                        </Tooltip>

                      </Fab>

                    </div>

                  </CardContent>
                  <br />
                  {/*<Button variant="contained" color="primary" className={classes.buttonVermas} disabled={datoICMODAL.SemaforoInformacion?.RegistroQuiebras ? false : true}  >Ver información</Button>*/}
                </div>

              </Card>

            </Grid>
            <Grid item xs={6} sm={6} xl={3} md={3} lg={3}  >
              <Card>
                <div className={classes.fondoCardIndicadores}><BallotOutlinedIcon className={classes.sizeIcono} /> <br />Registro de Protestos


                  <CardContent>

                    <div align="center">

                      <Fab
                        aria-label="save"
                        className={datoICMODAL.Resumenes?.ProtestosVigentes?.TotalDocumentos > 0 ? classes.ButtonDanger : datoICMODAL.Resumenes?.ProtestosVigentesSinacofi?.TotalDocumentos > 0 ? classes.ButtonDanger
                          : classes.buttonSuccess}
                        align="center"
                        size="small"
                      >
                        <Typography variant="h6" align="center" >{datoICMODAL.Resumenes?.ProtestosVigentes?.TotalDocumentos > 0 ? 'SI' : datoICMODAL.Resumenes?.ProtestosVigentesSinacofi?.TotalDocumentos > 0 ? 'SI' : 'NO'}</Typography>
                      </Fab>



                    </div>

                  </CardContent>
                  <hr />
                  {datoICMODAL.Resumenes?.ProtestosVigentes?.TotalDocumentos > 0 && datoICMODAL.Resumenes?.ProtestosVigentesSinacofi?.TotalDocumentos > 0 ? '' :
                    datoICMODAL.Resumenes?.ProtestosVigentes?.TotalDocumentos > 0 ? (
                      <TableContainer>

                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell>Total de Protesto: <strong>{datoICMODAL.Resumenes?.ProtestosVigentes?.TotalDocumentos}</strong></TableCell>

                            </TableRow>
                          </TableBody>
                        </Table>

                      </TableContainer>
                    ) :
                      datoICMODAL.Resumenes?.ProtestosVigentesSinacofi?.TotalDocumentos > 0 ? (
                        <TableContainer>

                          <Table>
                            <TableBody>
                              <TableRow>
                                <TableCell>Total de Protesto: <strong>{datoICMODAL.Resumenes?.ProtestosVigentesSinacofi?.TotalDocumentos}</strong></TableCell>

                              </TableRow>
                            </TableBody>
                          </Table>

                        </TableContainer>
                      ) :
                        ''}

                  <Button variant="contained" color="primary" className={classes.buttonVermas} onClick={hanleClickOpenProtesto} disabled={datoICMODAL && datoICMODAL.Resumenes?.ProtestosVigentes?.TotalDocumentos > 0 ? false : datoICMODAL.Resumenes?.ProtestosVigentesSinacofi.TotalDocumentos > 0 ? false : true} >Ver información</Button>
                </div>
              </Card>

            </Grid>

            <Grid item xs={6} sm={6} xl={3} md={3} lg={3}>
              <Card >
                <div className={classes.fondoCardIndicadores}><ImportContactsOutlinedIcon className={classes.sizeIcono} /><br />Boletín Laboral

                  <CardContent>
                    <div align="center">
                      <Fab
                        aria-label="save"
                        className={datoICMODAL.Resumenes?.BoletinLaboral?.TotalDocumentos > 0 ? classes.ButtonDanger : classes.buttonSuccess}
                        align="center"
                        size="small"

                      >
                        <Typography variant="h6" align="center" >{datoICMODAL.Resumenes?.BoletinLaboral?.TotalDocumentos > 0 ? 'SI' : 'NO'}</Typography>
                      </Fab>

                    </div>
                  </CardContent>
                  <hr />


                  {datoICMODAL.Resumenes?.BoletinLaboral?.TotalDocumentos > 0 ? (
                    <TableContainer>

                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>Boletin laboral:</TableCell>
                            <TableCell><strong>{datoICMODAL.Resumenes?.BoletinLaboral?.TotalDocumentos}</strong></TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>

                    </TableContainer>
                  ) : ''}

                  <br />
                  <Button variant="contained" color="primary" className={classes.buttonVermas} onClick={handleClickBoletin} disabled={datoICMODAL.Resumenes?.BoletinLaboral?.TotalDocumentos > 0 ? false : true} >Ver información</Button>
                </div>
              </Card>

            </Grid>

            <Grid item xs={6} sm={6} xl={3} md={3} lg={3} >
              <Card>
                <div className={classes.fondoCardIndicadores}>< AccountBalanceWalletOutlinedIcon className={classes.sizeIcono} /> <br /> Registra Morosidad

                <CardContent>
                    <div align="center">

                      <Fab
                        aria-label="save"
                        className={datoICMODAL && datoICMODAL.Resumenes?.MorosidadConsolidada?.TotalDocumentos > 0 ? classes.ButtonDanger :
                          datoICMODAL.Resumenes?.MorosidadConsolidadaSinacofi?.TotalDocumentos > 0 ? classes.ButtonDanger
                          : classes.buttonSuccess}
                        align="center"
                        size="small"
                      >
                        <Typography variant="h6" align="center"  >{datoICMODAL && datoICMODAL.Resumenes?.MorosidadConsolidada?.TotalDocumentos > 0 ? 'SI' : datoICMODAL.Resumenes?.MorosidadConsolidadaSinacofi?.TotalDocumentos > 0 ? 'SI' : 'NO'}</Typography>
                      </Fab>



                    </div>

                  </CardContent>
                  <hr />

                  {datoICMODAL && datoICMODAL.Resumenes?.MorosidadConsolidada?.TotalDocumentos > 0 && datoICMODAL.Resumenes?.MorosidadConsolidadaSinacofi?.TotalDocumentos > 0 ? ' '  : 
                  
                  datoICMODAL.Resumenes?.MorosidadConsolidada?.TotalDocumentos > 0 ?
                  
                  (
                    <TableContainer>

                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>Cant. Morosidades: <strong>{datoICMODAL && datoICMODAL.Resumenes?.MorosidadConsolidada?.TotalDocumentos}</strong></TableCell>
                          
                          </TableRow>
                        </TableBody>
                      </Table>

                    </TableContainer>
                  ) :
                  datoICMODAL.Resumenes?.MorosidadConsolidadaSinacofi?.TotalDocumentos > 0 ?  (
                    <TableContainer>

                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>Cant. Morosidades: <strong>{datoICMODAL && datoICMODAL.Resumenes?.MorosidadConsolidadaSinacofi?.TotalDocumentos}</strong></TableCell>
                          
                          </TableRow>
                        </TableBody>
                      </Table>

                    </TableContainer>
                  )
                  
                 : ' ' }

                  <br />
                  <Button variant="contained" color="primary" className={classes.buttonVermas} onClick={hanleClickOpenMorosidad} disabled={datoICMODAL && datoICMODAL.Resumenes?.MorosidadConsolidada?.TotalDocumentos > 0 || datoICMODAL.Resumenes?.MorosidadConsolidadaSinacofi?.TotalDocumentos >  0 ? false : true} >Ver información</Button>
                </div>
              </Card>

            </Grid>
          </Grid>
        </CardContent>
      </Grid>

    </div>
  )
}

export default IndicadoresPositivoNegativoModal
